// extracted by mini-css-extract-plugin
export var statItem = "_k6-1";
export var statsRow = "_k6-0";